import { toUnit } from '@ajaibid/components';
import { css } from '@emotion/css';

export const styStockIcon = ({ size }) => css`
  display: flex;
  margin: 0;
  padding: 0;
  height: ${toUnit(size)};
  width: ${toUnit(size)};
  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
  }
`;
